angular.module('dpw.components')
    .component('dpwCountrySelector', {
        templateUrl: 'dpw-country-selector.html',
        bindings: {
            width: '<',
            country: '=',
            isAll: "<"
        },
        controller: ['$scope', 'api', function ($scope, api) {
            var self = this;
            var topCountries = [
                {
                    id: '39',
                    name: 'Canada',
                    callingCode: '1'
                },
                {
                    id: '224',
                    name: 'United Kingdom',
                    callingCode: '44'
                },
                {
                    id: '1',
                    name: 'United States',
                    callingCode: '1',
                    isDefault: true
                }
            ];

            $scope.$watch('$ctrl.selectedCountry', function (newVal) {
                self.country = _.find(self.countries, {id: newVal});
            });

            self.$onInit = function () {
                api.call(api.country.list({
                    loginAllowed: self.isAll
                }), function (data) {
                    self.countries = transformCountries(data.countries);
                    self.selectedCountry = _.find(topCountries, {'isDefault': true}).id;
                    addA11y();
                });
            };

            function transformCountries(countries) {
                var topCountryId = _.map(topCountries, "id");
                var otherCountries = _.filter(countries, function (c) {
                    return !_.includes(topCountryId, c.id);
                });

                return topCountries.concat(otherCountries);
            }

            function addA11y() {
                var searchBox = document.querySelector('.chosen-search input');
                if (searchBox) {
                    searchBox.setAttribute('aria-label', 'Country Code Selector');
                }
            }

        }]
    });
